/**
 * @file header-getters.js
 */
import permissionGetters from './permission';

export default {
    ...permissionGetters,
    hasInputErrorStyle(state) {
        return state.isVcr || state.isFakeOfficial;
    },
    hasOutsideLenStyle(state) {
        return state.isOutside;
    }
};
